import { ErrorCode } from '../api/types'

export const getErrorCode = (err: any): ErrorCode =>
  err?.response?.data?.error?.errorCode || ErrorCode.OtherError
